import { LOCAL } from "@fantuaneats/chowbus-web-stripe-payment";
import accounting from "accounting";

export function JoinClassName(...classNameList: string[]) {
    return classNameList.join(" ");
}

export const AYDEN_LOG = '===Adyen Payment===';

export type PaymentLocalization = { [key in LOCAL]: { [key: string]: string } }

export enum DisplayFormatEnum {
    INTEGER = 1,
    DECIMAL = 2,
    PERCENTAGE = 3,
}

export function numberFormat(
    value: any,
    displayFormat: DisplayFormatEnum,
    displayPrecision: number = 2
): string {
    try {
        if (value === 0) {
            if (displayFormat === DisplayFormatEnum.PERCENTAGE) {
                return "0.00%";
            } else if (displayFormat === DisplayFormatEnum.DECIMAL) {
                return "0.00";
            } else {
                return "0";
            }
        }
        if (!value) {
            return "--";
        }
        if (displayFormat === DisplayFormatEnum.INTEGER) {
            if (value < 0 && value > -0.5) {
                return "0";
            }
            const result: string = accounting.formatNumber(value, 0);
            if (result === "-0") {
                return "0";
            }
            return result;
        } else if (displayFormat === DisplayFormatEnum.DECIMAL) {
            if (displayPrecision === 0) {
                return accounting.formatNumber(value, 0);
            } else {
                return accounting.formatNumber(value, displayPrecision || 2);
            }
        } else if (displayFormat === DisplayFormatEnum.PERCENTAGE) {
            return (
                accounting.formatNumber(
                    value * 100,
                    displayPrecision === null || displayPrecision === undefined ? 2 : displayPrecision
                ) + "%"
            );
        } else {
            return value;
        }
    } catch (error) {
        return "--";
    }
}


export const getPaymentError = () => {
    return `Oops! Something went wrong. Please try to payment again.\r\n哎呀，出错了。请重试一下！`;

};



export enum AdyenPaymentError {
    /** Network error. The provided session identifier or data is invalid*/
    NETWORK_ERROR = 'NETWORK_ERROR',
    /** Shopper canceled the current transaction. */
    CANCEL = 'CANCEL',
    /** Implementation error. The method or parameter are incorrect or are not supported. */
    IMPLEMENTATION_ERROR = 'IMPLEMENTATION_ERROR',
    /** API error. The API has not returned the expected data  */
    API_ERROR = 'API_ERROR',
    /** Generic error. */
    ERROR = 'ERROR',
    /** Script error. The browser failed to load 3rd party script */
    SCRIPT_ERROR = 'SCRIPT_ERROR',
    /** Something has gone wrong internally */
    SDK_ERROR = 'SDK_ERROR',
};

export enum AdyenPaymentResult {
    Authorised = 'Authorised',//The payment was successfully authorised.
    Cancelled = 'Cancelled',//	The payment was cancelled (by either the shopper or your own system) before processing was completed.
    Error = 'Error', //There was an error when the payment was being processed.
    Refused = 'Refused',//The payment was refused.
};

//Authorised //The payment was successfully authorised.
//Cancelled //	The payment was cancelled (by either the shopper or your own system) before processing was completed.
//Error //There was an error when the payment was being processed.
//Refused //The payment was refused.

export type AdyenPaymentResultCode = 'AuthenticationFinished' | 'AuthenticationNotRequired' | 'Authorised' | 'Cancelled' | 'ChallengeShopper' | 'Error' | 'IdentifyShopper' | 'PartiallyAuthorised' | 'Pending' | 'PresentToShopper' | 'Received' | 'RedirectShopper' | 'Refused';

export type AdyenPaymentSessionData = {
    sessionId: string;
    paymentPlatform: string;
    sessionData: string;
    delayCaptureSeconds: number;
    paymentId: string;
}

export type FetchAdyenPaymentSessionDataResult = {
    result: AdyenPaymentSessionData | null;
    message?: string;
}

export type CommonResultData<T> = {
    result: boolean;
    message?: string;
    data?: T;
}

export type AdyenPaymentEnhProps = {
    local: LOCAL;
    config: {
        environment?: 'test' | 'live' | 'live-us' | 'live-au' | 'live-apse' | 'live-in';
        clientKey: string;
    },
    paymentAmount: number;//需要支付的总金额
    getPaymentSession: () => Promise<FetchAdyenPaymentSessionDataResult>;
    onPaymentInitDone: () => void;
    onBeforePaymentStart: (para: { sessionData: AdyenPaymentSessionData }) => Promise<CommonResultData<any>>;//开始支付前处理一些特殊逻辑
    //Called when the payment succeeds.
    //The first parameter is the sessions response (when using sessions flow), or the result code.
    onPaymentComplete: (resultCode: AdyenPaymentResult, sessionData: AdyenPaymentSessionData, message?: string) => void;//支付完成
    //Called when the payment fails.
    //The first parameter is populated when merchant is using sessions, or when the payment was rejected
    //with an object. (Ex: 'action.reject(obj)' ). Otherwise, it will be empty.
    onPaymentFailed: (resultCode: AdyenPaymentResult, sessionData: AdyenPaymentSessionData, message?: string) => void;//支付失败,return by Adyen 
    // Callback called in two different scenarios:
    // - when a critical error happened (network error; implementation error; script failed to load)
    // - when the shopper cancels the payment flow in payment methods that have an overlay (GooglePay, PayPal, ApplePay)
    onUnExcepionError: (errorType: AdyenPaymentError, message?: string) => void;//maybe network
    //自定义的确认支付完成函数
    afterConfirmPayment: (para: { sessionData: AdyenPaymentSessionData }) => Promise<void>;
    onPayButtonIsReady: (fieldAllValid: boolean) => void;
    loadingIndicator?: (show: boolean) => void;

    localization: PaymentLocalization,
}


export function getMessage(message: string, values?: { [key: string]: string }) {
    if (!values) {
        return message;
    }
    return Object.keys(values).reduce((newMessage: string, key: string) => {
        newMessage = newMessage.replaceAll('{' + key + '}', values[key]);
        return newMessage;
    }, message)
}

export function buildDefaultPaymentCardInfo() {
    return {
        fingerprint: '',
        last4: '',
        country: '',
        funding: '',
        brand: '',
        exp_year: 0,
        exp_month: 0,
        wallet: {
            type: '',
        }
    }
}